var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.779 10.5502C25.1969 15.1872 20.2999 18.0678 15.0017 18.0678C9.70005 18.0678 4.80311 15.1872 2.22086 10.5502C2.02198 10.1901 2.02198 9.80947 2.22086 9.44972C4.80311 4.81272 9.70005 1.93247 15.0017 1.93247C20.2999 1.93247 25.1968 4.81272 27.779 9.44972C27.9814 9.80947 27.9814 10.1901 27.779 10.5502ZM29.4285 8.53034C26.5137 3.29491 20.9857 0.0429688 15.0017 0.0429688C9.01417 0.0429688 3.48623 3.29491 0.571357 8.53034C0.0501074 9.46447 0.0501074 10.5354 0.571357 11.4688C3.48623 16.7043 9.01417 19.9569 15.0017 19.9569C20.9857 19.9569 26.5137 16.7043 29.4285 11.4688C29.9498 10.5355 29.9498 9.46447 29.4285 8.53034ZM15.0017 13.8758C17.1381 13.8758 18.8767 12.1372 18.8767 9.99978C18.8767 7.86234 17.1381 6.12372 15.0017 6.12372C12.8618 6.12372 11.1232 7.86234 11.1232 9.99978C11.1232 12.1372 12.8619 13.8758 15.0017 13.8758ZM15.0017 4.23422C11.8193 4.23422 9.23367 6.82091 9.23367 9.99984C9.23367 13.1795 11.8194 15.7651 15.0017 15.7651C18.1806 15.7651 20.7662 13.1794 20.7662 9.99984C20.7662 6.82091 18.1806 4.23422 15.0017 4.23422Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.fd7467ce1059677b6f2daff4a99ce6fb.svg";
export { ForwardRef as ReactComponent };